export default "__VITE_ASSET__2E4q55VW__"